export enum ESurveyCategoryDisplay {
  confidence = 'Confidence',
  selfEfficacy = 'Self-Efficacy',
  attitude = 'Attitude',
  growthMindsetEffort = 'Growth Mindset (effort)',
  growthMindsetAbility = 'Growth Mindset (ability)',
  reasoningProcess = 'Reasoning (process)',
  reasoningPersistence = 'Reasoning (persistence)',
}

export type TSurveyCategory =
  | 'confidence'
  | 'selfEfficacy'
  | 'attitude'
  | 'growthMindsetEffort'
  | 'growthMindsetAbility'
  | 'reasoningProcess'
  | 'reasoningPersistence';

export type TSurveyStage = {
  category: TSurveyCategory;
  description: string;
};

export const surveyStages: TSurveyStage[] = [
  {
    category: 'confidence',
    description: 'I feel confident trying new or challenging math problems on my own.',
  },
  {
    category: 'selfEfficacy',
    description: 'I believe I can get better at mathematics with practice and effort.',
  },
  {
    category: 'attitude',
    description: 'I enjoy working on math problems, even when they take time to solve.',
  },
  {
    category: 'growthMindsetEffort',
    description:
      'When I make a mistake in mathematics, I see it as a chance to learn something new.',
  },
  {
    category: 'growthMindsetAbility',
    description:
      'I believe my mathematics skills can improve with hard work, no matter where I start.',
  },
  {
    category: 'reasoningProcess',
    description:
      'I like thinking through different ways to solve a mathematics problem before choosing one.',
  },
  {
    category: 'reasoningPersistence',
    description:
      'When a mathematics problem is hard, I keep trying different approaches until I figure it out.',
  },
];
